"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));

var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.function.name.js");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));

var _getSpeedLogData2 = _interopRequireDefault(require("@baidu/mvideo-scheme/lib/app/getSpeedLogData"));

var _is2 = _interopRequireDefault(require("@baidu/mvideo-scheme/lib/app/is"));

var _getVersion2 = _interopRequireDefault(require("@baidu/mvideo-scheme/lib/app/getVersion"));

var _uaDetect2 = _interopRequireDefault(require("@baidu/mvideo-tool/lib/uaDetect"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _spy = _interopRequireDefault(require("@baidu/spy"));

var _querystring = _interopRequireDefault(require("querystring"));

var _bdmedialiveScheme = _interopRequireDefault(require("@baidu/bdmedialive-scheme"));

var _event = _interopRequireDefault(require("./event"));

var _getClient = _interopRequireDefault(require("./getClient"));

var _getDiffTimeBySpeedStart = require("./getDiffTimeBySpeedStart");

var _getFmpMaxImgTime = _interopRequireDefault(require("./getFmpMaxImgTime"));

var _getFmpByAuto = require("./getFmpByAuto");

var _config = require("./config");

var _getNetworkType = _interopRequireDefault(require("./getNetworkType"));

var _listenImgErrorByFmp = _interopRequireDefault(require("./listenImgErrorByFmp"));

var _window, _context7, _context8, _context9;

var Speed = {
  // spy实例
  spyInstance: null,
  // 页面Speed配置
  vSpeedConfig: ((_window = window) === null || _window === void 0 ? void 0 : _window.vSpeedConfig) || {},
  // 上报数据主体
  data: {
    spyDim: {},
    // spy平台性能过滤指标
    isBaseInfoSended: false,
    // 是否已经发送过基础数据
    perfOriginalData: {},
    // 各阶段业务设置性能点，未修正过起始时间
    perfCorrectData: {} // 各阶段耗时数据，同起始时间修正过

  },

  /**
   * 性能统计启动
   * 区分是否端内(暂时全民)
   * 端内：
   *  获取端耗时 -> 设置性能起点 -> 依据性能起点，修正各阶段耗时
   *  页面onload -> 端能力发送性能日志
   * 端外：
   *  暂不处理
   *
   * @private
   */
  _start: function () {
    var _start2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this = this;

      var globalErrorCallback, data, status, speedData;
      return _regenerator.default.wrap(function _callee$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (window.performance) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              if (Speed.vSpeedConfig.group) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return");

            case 4:
              _context2.t0 = (0, _uaDetect2.default)().isIOS ? 'ios' : 'android';
              _context2.next = 7;
              return (0, _getNetworkType.default)();

            case 7:
              _context2.t1 = _context2.sent;
              _context2.t2 = (0, _getVersion2.default)() || 'other';
              _context2.t3 = (0, _getClient.default)();
              _context2.t4 = Number(_bdmedialiveScheme.default.env.is);
              Speed.data.spyDim = {
                os: _context2.t0,
                nettype: _context2.t1,
                clientversion: _context2.t2,
                client: _context2.t3,
                bmlwb: _context2.t4
              };
              Speed.spyInstance = new _spy.default({
                pid: Speed.vSpeedConfig.pid || '13_86',
                // 必须
                sample: 1 // 可选，默认为1, 全局抽样，取值：[0-1], 所有发送接口都受到该抽样，单个发送接口的sample配置会覆盖该抽样。

              });

              globalErrorCallback = function globalErrorCallback(event) {
                var eventError = event.error || {};
                var ErrorOption = (0, _assign.default)({}, {
                  // 可选，默认common
                  group: Speed.vSpeedConfig.group,
                  // 可选,维度信息
                  dim: Speed.data.spyDim,
                  info: {
                    msg: event.message,
                    // 不一定所有浏览器都支持col参数
                    colno: event.colno || event.column || window.event && window.event.errorCharacter,
                    lineno: event.lineno || event.line,
                    filename: event.filename || event.sourceURL,
                    stack: eventError.stack,
                    version: '1.1.21',
                    errortime: (0, _getDiffTimeBySpeedStart.getDiffTimeBySpeedStart)()
                  }
                });

                try {
                  var isFilterError = (0, _some.default)(_config.ERROR_FILTER_LIST).call(_config.ERROR_FILTER_LIST, function (regStr) {
                    var reg = eval("/^".concat(regStr, "/i"));
                    return reg.test(ErrorOption.info.msg);
                  }); // 过滤预期中的异常，例如 script error.

                  if (!isFilterError) {
                    Speed.spyInstance.sendExcept(ErrorOption);
                    _this.timerError && window.clearTimeout(_this.timerError);
                    _this.timerError = (0, _setTimeout2.default)(function () {
                      if (document.querySelector('.main') === null) {
                        ErrorOption.info.msg = "\u8FD9\u4E2A\u5F02\u5E38\u5BFC\u81F4\u9875\u9762\u767D\u5C4F: ".concat(ErrorOption.info.msg);
                      } else {
                        ErrorOption.info.msg = "\u8FD9\u4E2A\u5F02\u5E38\u4E0D\u5F71\u54CD\u9875\u9762\u6B63\u5E38\u8BBF\u95EE: ".concat(ErrorOption.info.msg);
                      }

                      Speed.spyInstance.sendExcept(ErrorOption);
                    }, 200);
                  }
                } catch (e) {
                  console.log(e);
                }
              };

              window.removeEventListener('error', globalErrorCallback);
              window.addEventListener('error', globalErrorCallback); // 供其它业务中报错使用

              window.sendExcept = function (msg) {
                // 避免报错影响正常业务
                try {
                  Speed.spyInstance.sendExcept({
                    group: Speed.vSpeedConfig.group,
                    dim: Speed.data.spyDim,
                    info: {
                      msg: msg
                    }
                  });
                } catch (e) {
                  console.log(e);
                }
              }; // 监听首屏图片加载情况，首屏40%以上图片异常，认定为白屏异常


              (0, _listenImgErrorByFmp.default)(document.getElementById('root'), function (failCount) {
                Speed.spyInstance.sendExcept({
                  group: Speed.vSpeedConfig.group,
                  // 必须, 异常信息，msg字段是必须的，是异常唯一标识。其他字段作为补充信息，由用户自定义
                  info: {
                    msg: 'fail to load img for FMP',
                    count: failCount
                  },
                  // 可选，维度信息，每个字段为一个维度，由用户自定义
                  dim: Speed.data.spyDim
                });
              }); // 获取端耗费的各部分时间点

              if (!Speed.data.spyDim.bmlwb) {
                _context2.next = 26;
                break;
              }

              // 泛知识直播中台
              Speed.setExtraSpyDim({
                bmlwb_vm: _bdmedialiveScheme.default.env.viewMode // 浏览模式

              });

              _bdmedialiveScheme.default.common.getNAPerfData().then(function (res) {
                var _res$data, _res$data3;

                // dim指标的 key长度超过30个字符的进行截取
                if (res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.dim) {
                  var _context, _res$data2;

                  var newDimObj = {};
                  (0, _forEach.default)(_context = (0, _keys.default)(res.data.dim)).call(_context, function (key) {
                    key.length > 30 ? newDimObj[(0, _slice.default)(key).call(key, 0, 30)] = res.data.dim[key] : newDimObj[key] = res.data.dim[key];
                  });
                  Speed.setExtraSpyDim(newDimObj);
                  res === null || res === void 0 ? true : (_res$data2 = res.data) === null || _res$data2 === void 0 ? true : delete _res$data2.dim;
                }

                (0, _assign.default)(Speed.data.perfCorrectData, res === null || res === void 0 ? void 0 : res.data);
                Speed.data.perfCorrectData.nt = _config.SPEED_START_TIME - (res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.entryStart); // 端耗时
              }).catch(function (err) {
                var _window2, _window2$console;

                (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$console = _window2.console) === null || _window2$console === void 0 ? void 0 : _window2$console.log(err);
              });

              if (_bdmedialiveScheme.default.canIUse('common.getRoomInfo')) {
                _bdmedialiveScheme.default.common.getRoomInfo().then(function (res) {
                  var _res$data4, _res$data5;

                  Speed.setExtraSpyDim({
                    templateId: res === null || res === void 0 ? void 0 : (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.templateId,
                    roomId: res === null || res === void 0 ? void 0 : (_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.roomId
                  });
                }).catch(function (err) {
                  var _window3, _window3$console;

                  (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$console = _window3.console) === null || _window3$console === void 0 ? void 0 : _window3$console.log(err);
                });
              }

              _bdmedialiveScheme.default.common.getCommonParams().then(function (res) {
                var _res$data6, _res$data7;

                var naCommonParams = _querystring.default.parse((res === null || res === void 0 ? void 0 : (_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : _res$data6.commonParams) || '');

                Speed.setExtraSpyDim({
                  client: naCommonParams === null || naCommonParams === void 0 ? void 0 : naCommonParams.appname,
                  cuid: ((naCommonParams === null || naCommonParams === void 0 ? void 0 : naCommonParams.uid) || '').substr(0, 25),
                  // spy: Length must be not more than 30
                  sdkversion: res === null || res === void 0 ? void 0 : (_res$data7 = res.data) === null || _res$data7 === void 0 ? void 0 : _res$data7.sdkVersion // clientversion: '' // 待补充

                });
              }).catch(function (err) {
                var _window4, _window4$console;

                (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$console = _window4.console) === null || _window4$console === void 0 ? void 0 : _window4$console.log(err);
              });

              _bdmedialiveScheme.default.common.getUserInfo().then(function (res) {
                var _res$data8, _res$data9;

                Speed.setExtraSpyDim({
                  isLogin: res === null || res === void 0 ? void 0 : (_res$data8 = res.data) === null || _res$data8 === void 0 ? void 0 : _res$data8.isLogin,
                  uk: res === null || res === void 0 ? void 0 : (_res$data9 = res.data) === null || _res$data9 === void 0 ? void 0 : _res$data9.userId
                });
              }).catch(function (err) {
                var _window5, _window5$console;

                (_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$console = _window5.console) === null || _window5$console === void 0 ? void 0 : _window5$console.log(err);
              });

              _context2.next = 40;
              break;

            case 26:
              if (!(0, _is2.default)()) {
                _context2.next = 40;
                break;
              }

              // 全民
              status = -1;
              _context2.prev = 28;
              _context2.next = 31;
              return (0, _getSpeedLogData2.default)();

            case 31:
              speedData = _context2.sent;
              data = speedData.data;
              status = speedData.status;
              _context2.next = 39;
              break;

            case 36:
              _context2.prev = 36;
              _context2.t5 = _context2["catch"](28);
              status = -1;

            case 39:
              if (status.toString() === '0') {
                Speed.data.perfCorrectData['nt'] = data['c_fet'] - data['c_ct']; // 端耗时
              }

            case 40:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee, null, [[28, 36]]);
    }));

    function _start() {
      return _start2.apply(this, arguments);
    }

    return _start;
  }(),

  /**
   * 基于performance api 计算各阶段耗时
   * @private
   */
  _getBasePerfomace: function _getBasePerfomace() {
    if (Speed.data.isBaseInfoSended) {
      return;
    }

    try {
      var timing = window.performance.timing;
      Speed.data.perfCorrectData['dns'] = timing.domainLookupEnd - timing.domainLookupStart; // DNS查找

      Speed.data.perfCorrectData['ct'] = timing.connectEnd - timing.connectStart; // 建立连接

      Speed.data.perfCorrectData['st'] = timing.responseStart - timing.requestStart; // 首字节到达(网络请求 + 后端耗时), dp(responseStart - connectEnd)

      Speed.data.perfCorrectData['tt'] = timing.responseEnd - timing.responseStart; // html传输完成

      if (timing.domComplete) {
        Speed.data.perfCorrectData['dct'] = timing.domComplete - timing.domLoading; // 页面解析完成
      }

      if (timing.domContentLoadedEventStart) {
        Speed.data.perfCorrectData['domready'] = timing.domContentLoadedEventStart - _config.SPEED_START_TIME; // dom构建完成
      }

      if (timing.loadEventEnd) {
        Speed.data.perfCorrectData['finish'] = timing.loadEventEnd - _config.SPEED_START_TIME; // 页面加载完成总耗时
      } // 页面模板底部自定义的 window.__perf_first_screen = Date.now()


      Speed.data.perfCorrectData.pfp = (0, _getDiffTimeBySpeedStart.getDiffTimeBySpeedStart)(window.__perf_first_screen); // ios不支持PerformancePaintTiming, 不上报

      if (!(0, _uaDetect2.default)().isIOS) {
        var paintEntries = window.performance.getEntriesByType('paint');
        (0, _forEach.default)(paintEntries).call(paintEntries, function (paintEntry) {
          if (paintEntry.name === 'first-paint') {
            // 白屏
            Speed.data.perfCorrectData['fp'] = paintEntry.startTime;
          } else if (paintEntry.name === 'first-contentful-paint') {
            Speed.data.perfCorrectData['fcp'] = paintEntry.startTime;
          }
        });
      }

      Speed.data.isBaseInfoSended = true;
    } catch (e) {
      console.log(e);
    }
  },

  /**
   * 设定自定义的性能过滤指标
   * @public
   * @param {Object} extraSpyDim 性能过滤指标对象
   */
  setExtraSpyDim: function setExtraSpyDim(extraSpyDim) {
    if (extraSpyDim && (0, _typeof2.default)(extraSpyDim) !== 'object') {
      return;
    }

    Speed.data.spyDim = (0, _assign.default)({}, Speed.data.spyDim, extraSpyDim);
  },

  /**
   * 发送性能统计
   * @param {object} info 主体信息
   * @returns {Promise}
   */
  sendPerf: function () {
    var _sendPerf = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(info) {
      var _context3;

      var sendInfo, perfData;
      return _regenerator.default.wrap(function _callee2$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (window.performance) {
                _context4.next = 2;
                break;
              }

              return _context4.abrupt("return");

            case 2:
              if (!(!Speed.vSpeedConfig.group || !Speed.vSpeedConfig.on)) {
                _context4.next = 4;
                break;
              }

              return _context4.abrupt("return");

            case 4:
              sendInfo = info ? info : Speed.data.perfCorrectData;

              if (!((0, _keys.default)(sendInfo).length === 0)) {
                _context4.next = 7;
                break;
              }

              return _context4.abrupt("return");

            case 7:
              (0, _forEach.default)(_context3 = (0, _keys.default)(sendInfo)).call(_context3, function (data) {
                sendInfo[data] = Math.round(sendInfo[data]);
              });
              perfData = {
                // 可选, 分组，默认common，用户自定义
                group: Speed.vSpeedConfig.group,
                // 必须, 指标信息，每个字段为一个指标，由用户自定义, 自己计算。
                info: sendInfo,
                // 可选，维度信息，每个字段为一个维度，由用户自定义
                dim: Speed.data.spyDim
              }; // navigator.sendBeacon

              Speed.spyInstance && Speed.spyInstance.sendPerf(perfData);

              _event.default.emit('sendPerf', perfData);

              !info && (Speed.data.perfCorrectData = {});
              return _context4.abrupt("return", perfData);

            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee2);
    }));

    function sendPerf(_x) {
      return _sendPerf.apply(this, arguments);
    }

    return sendPerf;
  }(),

  /**
   * 发送计数统计
   * @param {object} params 参数主体
   */
  sendCount: function () {
    var _sendCount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var _objectSpread2;

      var params,
          countData,
          _args3 = arguments;
      return _regenerator.default.wrap(function _callee3$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              params = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};

              if (Speed.vSpeedConfig.group) {
                _context5.next = 3;
                break;
              }

              return _context5.abrupt("return");

            case 3:
              countData = {
                // 可选, 分组，默认common，用户自定义
                group: params.group || Speed.vSpeedConfig.group,
                // 必须, 指标信息，每个字段为一个指标，由用户自定义
                info: (0, _objectSpread3.default)((_objectSpread2 = {}, (0, _defineProperty2.default)(_objectSpread2, Speed.vSpeedConfig.group, 1), (0, _defineProperty2.default)(_objectSpread2, "total_count", 1), _objectSpread2), params.info),
                // 可选，维度信息，每个字段为一个维度，由用户自定义
                dim: (0, _objectSpread3.default)((0, _objectSpread3.default)({}, Speed.data.spyDim), params.dim)
              };
              Speed.spyInstance.sendCount(countData);

              _event.default.emit('sendCount', countData);

              return _context5.abrupt("return", countData);

            case 7:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee3);
    }));

    function sendCount() {
      return _sendCount.apply(this, arguments);
    }

    return sendCount;
  }(),

  /**
   * 发送分布统计
   * @param {object} params 参数主体
   */
  sendDist: function () {
    var _sendDist = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      var params,
          distData,
          _args4 = arguments;
      return _regenerator.default.wrap(function _callee4$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              params = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};

              if (Speed.vSpeedConfig.group) {
                _context6.next = 3;
                break;
              }

              return _context6.abrupt("return");

            case 3:
              distData = {
                // 可选, 分组，默认common，用户自定义
                group: params.group || Speed.vSpeedConfig.group,
                // 必须, 指标信息，每个字段为一个指标，由用户自定义
                info: (0, _objectSpread3.default)({
                  group: String(Speed.vSpeedConfig.group),
                  bmlwb: String(Speed.data.spyDim.bmlwb),
                  bmlwb_vm: String(Speed.data.spyDim.bmlwb_vm),
                  isLogin: String(Speed.data.spyDim.isLogin),
                  // string兜底，防止spy内 .length判断报错
                  templateId: String(Speed.data.spyDim.templateId),
                  nettype: String(Speed.data.spyDim.nettype),
                  sdkversion: String(Speed.data.spyDim.sdkversion),
                  client: String(Speed.data.spyDim.client),
                  roomId: String(Speed.data.spyDim.roomId)
                }, params.info),
                // 可选，维度信息，每个字段为一个维度，由用户自定义
                dim: (0, _objectSpread3.default)((0, _objectSpread3.default)({}, Speed.data.spyDim), params.dim)
              };
              Speed.spyInstance.sendDist(distData);

              _event.default.emit('sendDist', distData);

              return _context6.abrupt("return", distData);

            case 7:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee4);
    }));

    function sendDist() {
      return _sendDist.apply(this, arguments);
    }

    return sendDist;
  }(),

  /**
   * 业务主动调用，认定获取当前时间下所有资源加载后为首屏
   */
  setFMPAndSendBySelf: function setFMPAndSendBySelf() {
    var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var fsTriggerTime = (0, _getDiffTimeBySpeedStart.getDiffTimeBySpeedStart)();
    (0, _getFmpMaxImgTime.default)(option).then(function (_ref) {
      var fsEndTime = _ref.fsEndTime,
          count = _ref.count,
          _ref$mainImg = _ref.mainImg,
          startTime = _ref$mainImg.startTime,
          endTime = _ref$mainImg.endTime,
          duration = _ref$mainImg.duration;

      Speed._getBasePerfomace(); // 首屏所有图片个数


      Speed.data.perfCorrectData['imgcount'] = count; // 首屏相关

      if (fsTriggerTime && fsEndTime) {
        Speed.data.perfCorrectData['imgmaxtime'] = fsEndTime;
        Speed.data.perfCorrectData['fmp'] = Math.max(fsTriggerTime, fsEndTime);
        Speed.data.perfCorrectData['fmptrigger'] = fsTriggerTime;
      } // 首屏大图


      if (option.mainImgUrl) {
        Speed.data.perfCorrectData['fmpsimg'] = startTime;
        Speed.data.perfCorrectData['fmpeimg'] = endTime;
        Speed.data.perfCorrectData['fmpimgduration'] = duration;
      } // 性能


      Speed.sendPerf();
    });
  },

  /**
   * 自动计算首屏并发送
   * @param {Object} domContainer 监听变化的父级dom
   */
  listenFmpByAuto: function listenFmpByAuto(domContainer) {
    if (!domContainer || !('MutationObserver' in window)) {
      return;
    } // 父组件的didmount触发，不会依赖子组件 didmount async的设定


    Speed.data.perfCorrectData['layoutdidmount'] = (0, _getDiffTimeBySpeedStart.getDiffTimeBySpeedStart)();
    (0, _getFmpByAuto.listenFMP)(domContainer).then(function (fmpTime) {
      (0, _getFmpMaxImgTime.default)({}).then(function (_ref2) {
        var fsEndTime = _ref2.fsEndTime,
            count = _ref2.count;

        Speed._getBasePerfomace(); // 首屏所有图片个数


        Speed.data.perfCorrectData['imgcount'] = count;

        if (fmpTime && fsEndTime) {
          Speed.data.perfCorrectData['imgmaxtime'] = fsEndTime;
          Speed.data.perfCorrectData['fmpauto'] = Math.max(fmpTime, fsEndTime);
          Speed.data.perfCorrectData['fmptriggerauto'] = fmpTime;
        } // 性能上报


        var perfData = Speed.sendPerf();

        _event.default.emit('fmpByAutoTriggered', perfData);
      });
    });
  },

  /**
   * 设定指标和结束时间，无结束时间最终计算使用统一开始时间算差值
   * @param {string} perfKey 性能名称
   * @param {number} perValue 该性能点结束时间
   * @private
   */
  _setAndSendPerf: function _setAndSendPerf(perfKey) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (perfKey === 'fmp') {
      // 首屏，计算成功就发送
      Speed.setFMPAndSendBySelf(option);
    } else if (perfKey === 'tti') {
      // 核心功能耗时
      Speed.data.perfCorrectData['tti'] = (0, _getDiffTimeBySpeedStart.getDiffTimeBySpeedStart)();
    }

    Speed.sendPerf();
  }
};

Speed._start();

var _default = (0, _objectSpread3.default)((0, _objectSpread3.default)({}, Speed.spyInstance), {}, {
  setExtraSpyDim: function setExtraSpyDim(option) {
    return Speed.setExtraSpyDim(option);
  },
  listenFmpByAuto: Speed.listenFmpByAuto,
  sendFMPBySelf: function sendFMPBySelf(option) {
    return Speed._setAndSendPerf('fmp', option);
  },
  sendTTI: function sendTTI() {
    return Speed._setAndSendPerf('tti');
  },
  send: Speed.sendPerf,
  sendCount: Speed.sendCount,
  sendDist: Speed.sendDist,
  on: (0, _bind.default)(_context7 = _event.default.on).call(_context7, _event.default),
  off: (0, _bind.default)(_context8 = _event.default.off).call(_context8, _event.default),
  emit: (0, _bind.default)(_context9 = _event.default.emit).call(_context9, _event.default)
});

exports.default = _default;